export default "__VITE_ASSET__dcb356af__"